module.exports = __webpack_public_path__ + "static/color_dragons_attack-4a8229d11c2b46ec9fa28a1d73ffe3ed.jpg";